<template>
  <div class="print-fabric-example d-flex flex-column justify-center align-center">
    <v-card
      tile
      height="189px"
      width="95px"
      class="bordered">
      <p
        class="pt-2 mb-0"
        style="font-size: 8px; font-family: Roboto, sans-serif">
        {{ sketchId }}
      </p>
      <v-divider class="my-2"></v-divider>
      <div
        style="line-height: 12px; white-space: pre-line; font-size: 8px; font-family: Roboto, sans-serif">
        {{ fabricLabel.labels || '' }}
      </div>
    </v-card>
    <p class="mt-4">
      จำนวนบรรทัด : <span :class="{ 'red--text': fabricLabel.textLine > maxLine }">{{ fabricLabel.textLine }} / {{ maxLine }}</span>
    </p>
  </div>
</template>

<script>
import ConvertFabricLabelToText from '@/assets/js/ConvertFabricLabelToText'

export default {
  props: {
    fabricCompositions: {
        type: Array,
        default: () => []
    },
    sketchId: {
      type: String,
      default: ''
    }
  },
  data () {
      return {
        maxLine: 11
      }
  },
  computed: {
    fabricLabel () {
      const fabrics = this.fabricCompositions.filter((fb) => fb.printInFabricLabel === true || typeof fb.printInFabricLabel !== 'boolean')
      return new ConvertFabricLabelToText(fabrics, this.maxLine)
    }
  }
}
</script>
